<template>
  <div class="company">
    <div class="company_top flex">
      <div class="company_top_left flex">
        <div class="company_left_box">
          <div class="company_border">
            <p class="company_left_title">友情链接</p>
          </div>
          <div class="company_top_list flex">
            <div class="">
              <a v-for="(items, index) in linksList" target="_blank" :href="items.value"
                ><p>{{ items.name }}</p></a
              >
            </div>
            <!--            <div>
              <a v-for="(items, index) in manufacturingList1" :href=items.linkUrl><p>{{ items.name }}</p></a>

            </div>-->
          </div>
        </div>
        <div class="company_left_box">
          <div class="company_border">
            <p class="company_left_title">产业园区</p>
          </div>
          <div class="company_top_list flex">
            <div>
              <a v-for="(items, index) in parkList" target="_blank"  :href="items.linkUrl"
                ><p>{{ items.name }}</p></a
              >
            </div>
          </div>
        </div>
        <div class="company_left_box">
          <div class="company_border">
            <p class="company_left_title">协议/规则</p>
          </div>
          <div class="company_top_list flex">
            <div>
              <div v-for="(items, index) in agreementLink" target="_blank"   :href="items.value"
                ><a :href="items.value" target="_blank"><p>{{ items.name }}</p></a></div
              >
            </div>
          </div>
        </div>
      </div>
      <div class="company_line"></div>
      <div class="company_top_right">
        <img class="advertisementPhoto" src="../../assets/advertisementPhoto.png" alt="">
        <div class="company_right_img">
          <img src="../../assets/whiteLogo.png" alt="" />
        </div>
        <p class="company_right_p1">联系电话：{{telephone}}</p>
        <p>公司地址：{{dizhivalue}}</p>
        <div class="flex company_right_bottom">
          <div class="company_right_two" v-for="code in qrCodeList">
            <div class="company_right_imgs">
              <img :src="code.value" alt="" />
            </div>
            <p>{{code.name}}</p>
          </div>
          <!--<div class="company_right_two">
            <div class="company_right_imgs">
              <img :src="erweima2" alt="" />
            </div>
            <p>{{groupName2}}</p>
          </div>
          <div class="company_right_two">
            <div class="company_right_imgs">
              <img :src="erweima2" alt="" />
            </div>
            <p>{{groupName2}}</p>
          </div>-->
        </div>
      </div>
    </div>
    <!--    <div class="company_center">
      <p>友情链接</p>
      <div>
        <a v-for="(items, index) in finance" :href=items.linkUrl><span>{{ items.name }} </span></a>
&lt;!&ndash;        <span>工业互联网平台</span>
        <span>工业互联网平台</span>
        <span>工业互联网平台</span>
        <span>工业互联网平台</span>
        <span>工业互联网平台</span>
        <span>工业互联网平台</span>&ndash;&gt;
      </div>
    </div>-->
    <div class="company_bottom">
      <div class="company_bottom_mess flex">
        <div class="flex company_bottom_box">
          <img src="../../assets/image/shenpin.jpg" style="float:left;"/>
          <p>皖公网安备 34022202000086号</p>
          <p style="margin-left: 20px">备案序号：皖ICP备2021013063号-1</p>
        </div>
        <div class="flex company_bottom_box">
          <p style="margin-right:16px">安徽增材云数字科技有限公司版权所有</p>
          <p>Copyright 2021 ZENGCAICLOUD. All rights reserved.</p>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { getIndexDictionaryData } from "../../utils/interface";
import { mapState } from "vuex";

export default {
  name: "Footer",

  data() {
    return {
      /*      //智能制造
      manufacturingList1: [],
      manufacturingList2: [],*/

      //协议 /规则
      agreementLink: [],
      //产业园区
      parkList: [],
      //友情链接
      linksList: [],

      // androidErcode: "",
      // iosErcode: "",

      setIn: null, // 定时器
      telephone:'',
      dizhivalue:'',
      // erweima1:'',
      // erweima2:'',
      // groupName:'',
      // groupName2:'',
      qrCodeList:[]
    };
  },
  created() {
    this.setIn = setInterval(() => {
      if (this.isTokenDoor === true) {
        clearInterval(this.setIn);
        // this.getManufacturing();
        this.getParkLink();
        this.getAgreementLink();
        this.getLinksList();
        this.getErcode();
        this.getTelephone()
        this.getDizhi()
        // this.getTwoMa()
      }
    }, 500);
  },
    computed: {
    ...mapState({
      isTokenDoor: "isTokenDoor",
    }),
  },
  mounted() {},
  methods: {
    getErcode() {
      getIndexDictionaryData({
        groupCode: "app",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          if (response.length > 0) {
            this.qrCodeList = response;
            /*for (let i = 0; i < response.length; i++) {
              if (response[i].name == "Android") {
                this.androidErcode = response[i].value;
              }
              if (response[i].name == "IOS") {
                this.iosErcode = response[i].value;
              }
            }*/
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getLinksList() {
      getIndexDictionaryData({
        groupCode: "YQLJ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          if (response.length > 0) {
            this.linksList = response;
          }
        })
        .catch(function (error) {
        });
    },

    getParkLink() {
      getIndexDictionaryData({
        groupCode: "CYYQ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          // console.log('jdfka',response );
          if (response.length > 0) {
            this.parkList = response;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },

    getAgreementLink() {
      getIndexDictionaryData({
        groupCode: "XYGZ",
        current: 1,
        pageSize: 10,
      })
        .then((response) => {
          if (response.length > 0) {
            this.agreementLink = response;
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTelephone() {
      getIndexDictionaryData({
        code: "LXDH",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.length > 0) {
            this.telephone = res[0].value
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getDizhi() {
      getIndexDictionaryData({
        code: "GSDZ",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          if (res.length > 0) {
            this.dizhivalue = res[0].value
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    getTwoMa(){
       getIndexDictionaryData({
        code: "IOS",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          this.erweima1 = res[0].value
          this.groupName = res[0].name
        })
        .catch(function (error) {
          console.log(error);
        });
        getIndexDictionaryData({
        code: "Android",
        current: 1,
        pageSize: 10,
      })
        .then((res) => {
          this.erweima2 = res[0].value
          this.groupName2 = res[0].name

        })
        .catch(function (error) {
          console.log(error);
        });
    }

    /*

    getManufacturing() {
      getIndexDictionaryData({
        groupCode: "ZNZZ",
        current: 1,
        pageSize: 20
      }).then((response) => {
        if (response.length > 0) {
          for (let i = 0; i < response.length; i++) {
            if (i < 7) {
              this.manufacturingList1.push(response[i]);
            } else {
              this.manufacturingList2.push(response[i]);
            }
          }
        }
        console.log('url',response)

      }).catch(function (error) {
        console.log(error);
      });
    },
*/
  },
};
</script>

<style scoped lang="less">
  .advertisementPhoto{
    width: 15vw;
    position: absolute;
    top: 20px;
    left: 170px;
  }
.company {
  background-color: #252525;
  /*padding: 42px 0 16px;*/
  background-size: 100% 100%;
  /*height: 414px;*/
  color: #bababa;

  .company_top {
    width: 1200px;
    margin: 0 auto;
    padding-top: 60px;

    .company_top_left {
      .company_left_box {
        margin-right: 30px;
        position: relative;
        .company_border {
          border-bottom: 1px solid #757575;

          .company_left_title {
            width: 100px;
            font-size: 20px;
            border-bottom: 1px solid #157efb;
            padding-bottom: 10px;
          }
        }

        .company_top_list {
          cursor: pointer;
          font-size: 12px;
          margin-top: 20px;
          &:nth-last-of-type(1){
          cursor:default;

          }

          div {
            width: 258px;
            line-height: 30px;
          }
          a {
            color: #bababa;
          }
          a:hover {
            color: #fff;
          }
        }
      }
    }

    .company_line {
      width: 1px;
      background: #505050;
      height: 226px;
      margin: 34px;
    }

    .company_top_right {
      font-size: 14px;
      position: relative;
      .company_right_img {
        height: 50px;

        img {
          height: 100%;
        }
      }

      .company_right_p1 {
        margin: 30px 0 24px;
      }

      .company_right_bottom {
        .company_right_two {
          text-align: center;
          margin-right: 30px;

          .company_right_imgs {
            margin-top: 40px;

            img {
              height: 100px;
            }
          }

          p {
            margin-top: 14px;
          }
        }
      }
    }
  }

  .company_center {
    width: 1200px;
    margin: 0 auto;
    font-size: 20px;
    padding-bottom: 24px;

    p {
      margin-bottom: 16px;
    }

    div {
      font-size: 14px;

      span {
        margin-right: 18px;
        color: #bababa;
      }
      span:hover {
        color: #fff;
      }
    }
  }

  .company_bottom {
    margin-top: 40px;
    height: 60px;
    background: #181818;
    font-size: 14px;

    .company_bottom_mess {
      width: 1200px;
      justify-content: space-between;
      margin: 0 auto;
      line-height: 60px;
      .company_bottom_box {
        align-items: center;
        img {
          margin-right: 8px;
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/footer/index.vue